import { Navigate } from "react-router-dom";

import { NotFoundView } from "@/components/_molecules/not-found-view";
import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { lazyRoute } from "@/routes/lazy-route";
import { ProtectedRoute } from "@/routes/protected-route";

const AdminRootLayout = lazyRoute(() => import("./admin/admin-root.layout"), "AdminRootLayout");
const AdminWorkspaceAllPage = lazyRoute(() => import("./admin/admin-workspace-all.page"), "AdminWorkspaceAllPage");
const AdminAnalyticsPage = lazyRoute(() => import("./admin/admin-analytics.page"), "AdminAnalyticsPage");
const AdminAnalyticsWorkspacePage = lazyRoute(() => import("./admin/admin-analytics-workspace.page"), "AdminAnalyticsWorkspacePage");
const AdminUsersPage = lazyRoute(() => import("./admin/admin-users.page"), "AdminUsersPage");
const AdminUserProfilePage = lazyRoute(() => import("./admin/admin-user-profile.page"), "AdminUserProfilePage");
const AdminActivityPage = lazyRoute(() => import("./admin/admin-activity.page"), "AdminActivityPage");
const AdminSalesPage = lazyRoute(() => import("./admin/admin-sales.page"), "AdminSalesPage");
const OfferingAdminEditPage = lazyRoute(() => import("@/domain/offering/routes/admin/offering-admin-edit.page"), "OfferingAdminEditPage");
const AdminFundingImportsPage = lazyRoute(() => import("@/domain/funding-program/routes/admin-funding-imports.page"), "AdminFundingImportsPage");
const AdminIdentityProviderListPage = lazyRoute(() => import("@/domain/identity-provider/routes/admin/admin-identity-provider-list.page"), "AdminIdentityProviderListPage");
const AdminIdentityProviderCreatePage = lazyRoute(() => import("@/domain/identity-provider/routes/admin/admin-identity-provider-create.page"), "AdminIdentityProviderCreatePage");
const WorkspaceSettingsAppearancePage = lazyRoute(() => import("./workspace-settings-appearance.page"), "WorkspaceSettingsAppearancePage");
const WorkspaceSettingsGeneralPage = lazyRoute(() => import("./workspace-settings-general.page"), "WorkspaceSettingsGeneralPage");
const WorkspaceSettingsMembershipPage = lazyRoute(() => import("./workspace-settings-membership.page"), "WorkspaceSettingsMembershipPage");
const WorkspacePopulationSettingsPage = lazyRoute(() => import("./workspace-population-settings.page"), "WorkspacePopulationSettingsPage");

export const workspaceSettingsRoutes = [
  { path: "", element: <Navigate to="general" replace /> },
  { path: "general", element: <WorkspaceSettingsGeneralPage /> },
  { path: "members", element: <WorkspaceSettingsMembershipPage /> },
  { path: "appearance", element: <WorkspaceSettingsAppearancePage /> },
  {
    path: "population",
    element: (
      <FeatureFlagToggle
        flag="enable-ageb-data"
        isDevelopmentBypassAllowed={false}
        fallback={<Navigate to=".." relative="path" replace />}
      >
        <WorkspacePopulationSettingsPage />
      </FeatureFlagToggle>
    ),
  },
];

export const workspaceAdminRoutes = (isAuthenticated: boolean) => {
  return [
    {
      path: "/admin",
      element: <ProtectedRoute isAuthenticated={isAuthenticated}>{<AdminRootLayout />}</ProtectedRoute>,
      children: [
        { path: "", element: <Navigate to="workspaces" replace /> },
        { path: "workspaces", element: <AdminWorkspaceAllPage /> },
        { path: "analytics", element: <AdminAnalyticsPage /> },
        { path: "analytics/:workspaceUrl", element: <AdminAnalyticsWorkspacePage /> },
        { path: "users", element: <AdminUsersPage /> },
        { path: "users/:userId", element: <AdminUserProfilePage /> },
        { path: "activity", element: <AdminActivityPage /> },
        { path: "sales", element: <AdminSalesPage /> },
        { path: "offering", element: <Navigate to="/admin/sales?tab=offerings" replace /> },
        { path: "offering/new", element: <OfferingAdminEditPage /> },
        { path: "offering/:offeringId", element: <OfferingAdminEditPage /> },
        { path: "invoices", element: <Navigate to="/admin/sales?tab=orders" replace /> },
        { path: "upsell-features", element: <Navigate to="/admin/sales" replace /> },
        { path: "funding-imports", element: <AdminFundingImportsPage /> },
        { path: "identity-providers", element: <AdminIdentityProviderListPage /> },
        { path: "identity-providers/new", element: <AdminIdentityProviderCreatePage /> },
        { path: "*", element: <NotFoundView /> },
      ],
    },
  ];
};
